import {
  faBan,
  faMicrochip,
  faPencilAlt,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { observer } from "mobx-react";
import React, { SyntheticEvent, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import SlidingPanel from "react-sliding-side-panel";
import no_user from "../../assets/Images/svg/nofotajet.svg";
import fotaFileTypeEnum from "../../constants/fota-file-type-enum";
import FotaStatusEnum from "../../constants/fota-status-enum";
import fotaViewTypeEnum, {
  ModuleToOpen,
} from "../../constants/fota-view-type-enum";
import systemModuleEnum from "../../constants/system-module-enum";
import userSettingEnum from "../../constants/user-setting-enum";
import { useStore } from "../../contexts/StoreProvider";
import {
  isOperationPermitted,
  showIcons,
} from "../../helpers/action-permission-helper";
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from "../../models/ICommon";
import {
  IFotaDeviceStatusParentData,
  IFotaHostScheduleList,
} from "../../models/response/IFotaNewResponse";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import Grid from "../../shared-components/Grid/Grid";
import { ActionFormatter } from "../../shared-components/Grid/GridFormatter";
import Pagination from "../../shared-components/Grid/Pagination";
import AbortPopupHOC from "../../shared-components/popup/abort/abort-popup-hoc";
import AddPopupHOC from "../../shared-components/popup/add/add-popup-hoc";
import DeletePopup from "../../shared-components/popup/delete/delete-popup";
import DeletePopupHOC from "../../shared-components/popup/delete/delete-popup-hoc";
import ShowPopupHOC from "../../shared-components/popup/show/show-popup-hoc";
import RoutesConstants from "../../shared-components/Routes/routes.constants";
import { formatMessage } from "../../translations/format-message";
import AddEditFotaTenant from "./components/add-edit-fota-tenant";
import FotaTenantDetails from "./components/fota-tenant-detail";
import ScheduleFirmwareUpdate from "./components/schedule-firmware-update";
import "./fota-tnt-release.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AbortIconSVG from "../../shared-components/svg/abort";
import DisableAbortIconSVG from "../../shared-components/svg/disable-abort";
import CantAbortIconSVG from "../../shared-components/svg/cant-abort";
import _ from "lodash";

const FotaHostView = (props: any) => {
  const history = useHistory();
  const { preferencesStore, fotaTntReleaseStore, schedulerHistoryStore } = useStore();
  const {
    addUpdateFotaState,
    resetAddUpdateFotaState,
    error,
    inProgress,
    reset,
    GetFotaHostConfigListService,
    getFotaHostConfigList,
    resetFotaHostConfigState,
    DeleteFotaHostConfigService,
    resetDeleteFotaHostConfigState,
    deleteFotaHostConfigState,
    fotaHostConfigList,
    GetFotaHostScheduleListService,
    getFotaHostScheduleList,
    resetFotaHostScheduleState,
    DeleteFotaHostScheduleService,
    resetDeleteFotaHostScheduleState,
    deleteFotaHostScheduleState,
    fotaHostScheduleList,
    setSelectedView,
    isSelectedView,
    isAddUpdatePopupOpen,
    setIsAddUpdatePopupOpen,
    filterDetails,
    setFilterDetail,
  } = fotaTntReleaseStore;
  const {
    userSetting,
    setUserSetting,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const {
    AbortFotaDeviceHostScheduleByScheduleIdService,
    abortDeviceScheduleState,
    resetAbortDeviceScheduleState,
  } = schedulerHistoryStore;
  const {
    selectedId,
    setSelectedId,
    selectedRow,
    setSelectedRow,
    openPanel,
    setOpenPanel,
    closePanelHandler,
    pageInfo,
    setPageInfo
  } = props;
  const pageLimitOptions: Array<number> = [10, 50, 100, 1000];
  const [disablePagination, setDisablePagination] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.fotaLimitConfig,
    isPageLimitChange: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages:
        isSelectedView.moduleToOpen === ModuleToOpen.Config
          ? fotaHostConfigList?.PagingDetails?.TotalPages
          : fotaHostScheduleList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.FotaLimitConfig, parseInt(evt.target.value));
  };

  /**
   * This function calls the "GetFotaMzlReleaseListService" store funtion that get fota release list from API
   */
  const callGetFotaListService = () => {
    if (isSelectedView.view == fotaViewTypeEnum.Host && isSelectedView.moduleToOpen === ModuleToOpen.Config)
      GetFotaHostConfigListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit
      );
    else if (isSelectedView.view == fotaViewTypeEnum.Host && isSelectedView.moduleToOpen === ModuleToOpen.Schedule)
      GetFotaHostScheduleListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        filterDetails
      );
  };

  /**
   * This function shows the add group pop up from where we can add new group and update existing group prootcol. we use id to identify
   * that we are adding or updating group.
   * "Id == -1" : we are adding new group
   * "Id != -1" : means we are updating existing group
   */
  const openAddPopupHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    closePanelHandler();
    setSelectedId(row.Id);
    setIsAddUpdatePopupOpen(true);
  };
  /**
   * This function shows the delete user confirmation popup component and sets the seleted user Id
   */
  const deleteClickHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    setSelectedId(row.Id);
    props.deletePopupToggleHandler();
  };

  const historyClickHandler = (
    row: IFotaHostScheduleList,
    event: SyntheticEvent,
    isSelectedTabView: fotaViewTypeEnum
  ) => {
    event.stopPropagation();
    let tempState: IFotaDeviceStatusParentData = {
      Id: row.Id,
      ScheduleDate: row.ScheduleDate,
      ScheduleExpirationDate: row.ScheduleExpirationDate,
      Version: row.ConfigVersion,
      FileType: row.Config?.FileType || 0,
    };
    history.push({
      pathname: RoutesConstants.FotaDeviceStatus,
      state: {
        selectedRecord: { ...tempState },
        isSelectedTabView
      },

    });
  };

  const abortHandler = () => {
    AbortFotaDeviceHostScheduleByScheduleIdService(selectedId);
  };

  const abortPopupOpenHandler = (
    row: IFotaHostScheduleList,
    event: SyntheticEvent
  ) => {
    event.stopPropagation();
    setSelectedId(row.Id);
    props.abortPopupToggleHandler();
  };

  /**
   * This function deletes the user by providing Id to the Api
   */
  const deleteHandler = () => {
    if (isSelectedView.moduleToOpen === ModuleToOpen.Config)
      DeleteFotaHostConfigService(selectedId);
    else DeleteFotaHostScheduleService(selectedId);
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageLimitInfo.pageLimit" of the useEffect changed.
   */
  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      callGetFotaListService();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "GroupList" of the useEffect changed.
   */
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages:
        isSelectedView.moduleToOpen === ModuleToOpen.Config
          ? fotaHostConfigList?.PagingDetails?.TotalPages
          : fotaHostScheduleList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFotaHostConfigList, getFotaHostScheduleList]);

  // useEffect(() => {
  //   return () => {
  //     resetStore();
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (filterDetails.isFilterActive) callGetFotaListService();
    else {
      callGetFotaListService();
    }
  }, [filterDetails]);

  useEffect(() => {
    if (isSelectedView.isViewChanged) {
      setSelectedView({ ...isSelectedView, isViewChanged: false });
      callGetFotaListService();
      setPageInfo({
        ...pageInfo,
        currentPage: 1,
        isRefreshPage: true,
        isPagerChange: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedView.isViewChanged]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (
      deleteFotaHostConfigState.success ||
      deleteFotaHostScheduleState.success
    ) {
      toast.success(formatMessage("deleted_success"));
      if (isSelectedView.moduleToOpen === ModuleToOpen.Config)
        resetDeleteFotaHostConfigState();
      else resetDeleteFotaHostScheduleState();
      props.deletePopupToggleHandler();
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    deleteFotaHostConfigState.success,
    deleteFotaHostScheduleState.inProgress,
  ]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (abortDeviceScheduleState.success) {
      toast.success(formatMessage("abort_success"));
      setSelectedId(-1);
      resetAbortDeviceScheduleState();
      callGetFotaListService();
      props.abortPopupToggleHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abortDeviceScheduleState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaError" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteFotaHostConfigState.error) {
      toast.error(formatMessage(deleteFotaHostConfigState.error));
      resetDeleteFotaHostConfigState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFotaHostConfigState.error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaError" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteFotaHostScheduleState.error) {
      toast.error(formatMessage(deleteFotaHostScheduleState.error));
      resetDeleteFotaHostConfigState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFotaHostScheduleState.error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateGroupstate.success" of the useEffect changed.
   */
  useEffect(() => {
    if (isSelectedView.view === fotaViewTypeEnum.Host && addUpdateFotaState.success) {
      resetAddUpdateFotaState();
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateFotaState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "islanguageChanged" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      callGetFotaListService();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  function rowClassFormat(row: any, rowIdx: number) {
    let className: string = "";
    if (selectedId && row.Id === selectedId) {
      className = "bg-row SelectedRow";
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedId(row.Id);
    setSelectedRow(row);
    setOpenPanel(true);
  };

  const getSelectedTabLandingpageNoRecordMessage = () => {
    if (isSelectedView.view == fotaViewTypeEnum.Host && isSelectedView.moduleToOpen == ModuleToOpen.Config) {
      return <FormattedMessage id="no_fota_config" />;
    }
    else if (isSelectedView.view == fotaViewTypeEnum.Host && isSelectedView.moduleToOpen == ModuleToOpen.Schedule) {
      return <FormattedMessage id="no_fota_schedule" />;
    }
  };
  const getSelectedTabLandingpageNoRecordFullMessage = () => {
    if (isSelectedView.view == fotaViewTypeEnum.Host && isSelectedView.moduleToOpen == ModuleToOpen.Config) {
      return <FormattedMessage id="no_fota_config_msg" />;
    }
    else if (isSelectedView.view == fotaViewTypeEnum.Host && isSelectedView.moduleToOpen == ModuleToOpen.Schedule) {
      return <FormattedMessage id="no_fota_schedule_msg" />;
    }
  };
  const getSelectedTabLandingpageButtonMessageKey = () => {
    if (isSelectedView.view == fotaViewTypeEnum.Host && isSelectedView.moduleToOpen == ModuleToOpen.Config) {
      return "add_configuration";
    }
    else if (isSelectedView.view == fotaViewTypeEnum.Host && isSelectedView.moduleToOpen == ModuleToOpen.Schedule) {
      return "add_schedule";
    }
  };
  const getFotaFileTypeHandler = (fileType: fotaFileTypeEnum) => {
    if (fileType == fotaFileTypeEnum.NoConvert) return formatMessage("no_convert");
    else if (fileType == fotaFileTypeEnum.ASCII) return formatMessage("ASCII");
    else return "";
  };


  const actionIcons: IActionFormatter[] = showIcons(
    [
      {
        dataField: "isEdit",
        handler: openAddPopupHandler,
        icon: faPencilAlt,
        isDisable: false,
        title: "edit",
        action: "edit",
        varient: "primary",
      },
      {
        dataField: "isDelete",
        handler: deleteClickHandler,
        icon: faTrashAlt,
        isDisable: true,
        title: "delete",
        action: "delete",
        varient: "danger",
      },
    ],
    systemModuleEnum.Fota
  );

  const schedulerIcons: IActionFormatter[] = showIcons(
    [
      {
        dataField: "isEdit",
        handler: openAddPopupHandler,
        icon: faPencilAlt,
        isDisable: true,
        title: "edit",
        action: "edit",
        varient: "primary",
      },
      {
        dataField: "isDelete",
        handler: deleteClickHandler,
        icon: faTrashAlt,
        isDisable: true,
        title: "delete",
        action: "delete",
        varient: "danger",
      },
      {
        dataField: "isHistory",
        handler: historyClickHandler,
        icon: faMicrochip,
        isDisable: true,
        title: "devices_status",
        varient: "primary",
      },
      {
        dataField: "isAbort",
        handler: abortPopupOpenHandler,
        icon: faBan,
        isDisable: true,
        title: "abort_schedule",
        varient: "primary",
      },
    ],
    systemModuleEnum.Fota
  );

  const configColumns: any = [
    {
      dataField: "CreatedDate",
      text: formatMessage("created_date"),
    },
    {
      dataField: "ConfigName",
      text: formatMessage("fota_config_name"),
    },
    {
      dataField: "Version",
      text: formatMessage("version"),
    },
    {
      dataField: "FileType",
      text: formatMessage("sending_method"),
      formatter: (cell: any, row: any) => {
        return (
          <>
            <span>{getFotaFileTypeHandler(cell)}</span>
          </>
        );
      },
    },
    {
      dataField: "FileName",
      text: formatMessage("file_name"),
      // hidden: isSelectedView !== fotaViewTypeEnum.Host ? false : true
    },
    {
      dataField: "Description",
      text: formatMessage("fota_desc"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "",
      formatter: ActionFormatter(actionIcons),
      text: formatMessage("actions"),
      hidden: actionIcons.length === 0 ? true : false,
    },
  ];

  const scheduleColumns: any = [
    {
      dataField: "ScheduleDate",
      text: formatMessage("schedule_date"),
    },
    {
      dataField: "ScheduleExpirationDate",
      text: formatMessage("schedule_expiration_date"),
    },
    {
      dataField: "ConfigName",
      text: formatMessage("fota_config_name"),
    },
    {
      dataField: "ConfigVersion",
      text: formatMessage("config_version"),
    },
    {
      dataField: "Description",
      text: formatMessage("fota_desc"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "Status",
      formatter: (cell: number, row: any) => {
        return (<FormattedMessage id={FotaStatusEnum[cell]} />);
      },
      text: formatMessage("status"),
    },
    {
      dataField: "Progress",
      text: formatMessage("progress_percent"),
    },
    {
      dataField: "",
      text: formatMessage("actions"),
      hidden: actionIcons.length === 0 ? true : false,
      formatter: (cell: any, row: IFotaHostScheduleList) => {
        return (
          <>
            <div className="btn-group">
              {/* [DeepakPaliwal, When Schedule Date fota works then will uncommnet this code section ]
               {isOperationPermitted(systemModuleEnum.Fota, "Edit") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="edit"
                  title={formatMessage("edit")}
                  type="button"
                  disabled={!row.isEdit}
                  onClick={(event) => openAddPopupHandler(row, event)}
                >
                  <FontAwesomeIcon icon={faPencilAlt} />
                </button>
              )} */}
              {isOperationPermitted(systemModuleEnum.Fota, "Delete") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="delete"
                  title={formatMessage("delete")}
                  type="button"
                  disabled={!row.isDelete}
                  onClick={(event) => deleteClickHandler(row, event)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              )}
              {isOperationPermitted(systemModuleEnum.Fota, "View") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="fota_device_status"
                  title={formatMessage("fota_device_status")}
                  type="button"
                  disabled={!row.isHistory}
                  onClick={(event) => historyClickHandler(row, event, fotaViewTypeEnum.Host)}
                >
                  <FontAwesomeIcon icon={faMicrochip} />
                </button>
              )}
              {isOperationPermitted(systemModuleEnum.Fota, "Edit") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="abort_schedule"
                  title={formatMessage((row.IsScheduleAborted || row.Status === FotaStatusEnum.Aborted) ? "schedule_aborted" : ((row.Status === FotaStatusEnum.Pending || row.Status === FotaStatusEnum.Success || row.Status === FotaStatusEnum.None || row.Status === FotaStatusEnum.Failed) ? "cant_abort" : "abort_schedule"))}
                  type="button"
                  disabled={!row.isAbort}
                  onClick={(event) => abortPopupOpenHandler(row, event)}
                >
                  {
                    (row.IsScheduleAborted || row.Status === FotaStatusEnum.Aborted) ?
                      <DisableAbortIconSVG /> :
                      // <AbortIconSVG /> :
                      ((row.Status === FotaStatusEnum.Pending || row.Status === FotaStatusEnum.Success || row.Status === FotaStatusEnum.None || row.Status === FotaStatusEnum.Failed) ?
                        <CantAbortIconSVG /> :
                        <AbortIconSVG />)
                  }
                </button>
              )}
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      {isAddUpdatePopupOpen && (
        <>
          {isSelectedView.view === fotaViewTypeEnum.Host &&
            isSelectedView.moduleToOpen === ModuleToOpen.Config ? (
            <AddEditFotaTenant
              id={selectedId}
              modalClosed={() => {
                setIsAddUpdatePopupOpen(false);
              }}
            />
          ) : (
            <ScheduleFirmwareUpdate
              schedulerId={selectedId}
              modalClosed={() => {
                setIsAddUpdatePopupOpen(false);
              }}
            />
          )}
        </>
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title={
            isSelectedView.moduleToOpen === ModuleToOpen.Config
              ? "delete_host_config"
              : "delete_host_schedule"
          }
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message={
            isSelectedView.moduleToOpen === ModuleToOpen.Config
              ? "message_delete_host_config_confirm"
              : "message_delete_host_schedule_confirm"
          }
          isLoading={deleteFotaHostConfigState.inProgress}
        />
      )}
      {/*Aort confirm popup */}
      {props.showAbortPopup && (
        <DeletePopup
          title="abort_schedule_confirm"
          modalSubmit={abortHandler}
          modalClosed={props.abortPopupToggleHandler}
          message="message_abort_host_schedule_confirm"
          isLoading={abortDeviceScheduleState.inProgress}
        />
      )}
      <div className="table_items_list">
        {inProgress && <FormLoader loading={inProgress} />}
        {getFotaHostConfigList.length > 0 ||
          getFotaHostScheduleList.length > 0 ? (
          <div
            className={`card mt-3 changingPanel ${openPanel ? "panelOpen" : ""
              }`}
          >
            <div className="tableDesign row-eq-height tableDevices ">
              <div className="table-responsive" data-testid="table">
                {isSelectedView.moduleToOpen === ModuleToOpen.Config ? (
                  <Grid
                    data={getFotaHostConfigList}
                    columns={configColumns}
                    keyField="Id"
                    loading={inProgress}
                  // rowEvents={{ onClick: rowEvents }}
                  // rowClasses={rowClassFormat}
                  />
                ) : (
                  <Grid
                    data={getFotaHostScheduleList}
                    columns={scheduleColumns}
                    keyField="Id"
                    loading={inProgress}
                    rowEvents={{ onClick: rowEvents }}
                    rowClasses={rowClassFormat}
                  />
                )}
              </div>
            </div>

            {(getFotaHostConfigList.length > 0 || getFotaHostScheduleList.length > 0) ? (
              <div className="row g-0 p-2 tableFooter">
                <div className="col-sm-6 pt-1">
                  <FormattedMessage id="show" />
                  <select
                    data-testid="pageSelect"
                    className="pageLimit"
                    onChange={onPageLimitChanged}
                    value={pageLimitInfo.pageLimit}
                  >
                    {pageLimitOptions.map((op: any) => (
                      <option key={op} value={op}>
                        {op}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6 d-flex justify-content-sm-end">
                  <Pagination
                    isRefreshPage={false}
                    totalPages={pageInfo.totalPages}
                    pageLimit={pageLimitInfo.pageLimit}
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="message text-center">
            <img src={no_user} alt="" className="no_message" />
            <p className="noData text-muted text-center h4 mb-0">
              {
                getSelectedTabLandingpageNoRecordMessage()
              }
            </p>
            <p className="mb-3">{getSelectedTabLandingpageNoRecordFullMessage()}</p>
            {isOperationPermitted(systemModuleEnum.Fota, "Add") && (
              <LoaderButton
                text={getSelectedTabLandingpageButtonMessageKey()}
                onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
                  openAddPopupHandler({ Id: -1 }, e)
                }
              />
            )}
          </div>
        )}
      </div>
      <SlidingPanel
        type={"right"}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel order_details_panel">
          <div className="row bb p-2 g-0">
            <div className="col-lg-11">
              <h2 className="fw-bold mb-0 mt-2">{selectedRow.ScheduleDate}</h2>
            </div>
            <div className="col-lg-1 text-end">
              <button
                onClick={closePanelHandler}
                className="Crossicons"
                title={formatMessage("close")}
              >
                <svg
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>
          <FotaTenantDetails selectedData={selectedRow} />
        </div>
      </SlidingPanel>
    </>
  );
};

export default AbortPopupHOC(
  DeletePopupHOC(ShowPopupHOC(AddPopupHOC(observer(FotaHostView))))
);
